/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { type ReactElement } from 'react';

/**
 * Loading placeholder for the promo banner — an empty nutrient-orange band at the banner's height.
 * Reserves space while the global promo page streams in (the banner sits above the fold, so a
 * `null` fallback would shift the page; see CLAUDE.md rule #8). Renders only during loading: a
 * missing or empty promo page resolves to nothing, so no empty bar lingers.
 */
export default function PromoBannerSkeleton(): ReactElement {
    return <div className="min-h-10 w-full bg-bm-orange-700" aria-hidden="true" />;
}
